import React, { useMemo } from 'react';
import { Layout, Menu, theme } from 'antd';
import type { MenuProps } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  ADMIN_TOP_ITEMS,
  ADMIN_GROUPS,
  getActiveAdminKey,
} from '../config/navigation.config';
import layoutStyles from '../styles/layouts/AdminLayout.module.scss';

const { Sider, Content } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

const AdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const items: MenuItem[] = useMemo(() => {
    const topItems: MenuItem[] = ADMIN_TOP_ITEMS.map((item) => ({
      key: item.key,
      icon: item.icon,
      label: item.label,
      onClick: () => navigate(item.path),
    }));

    const groupItems: MenuItem[] = ADMIN_GROUPS.map((group) => ({
      key: group.key,
      label: group.label,
      type: 'group' as const,
      children: group.children.map((child) => ({
        key: child.key,
        icon: child.icon,
        label: child.label,
        onClick: () => navigate(child.path),
      })),
    }));

    return [...topItems, ...groupItems];
  }, [navigate]);

  const activeKey = useMemo(
    () => getActiveAdminKey(location.pathname),
    [location.pathname]
  );

  return (
    <Layout className={layoutStyles.adminLayout}>
      <Sider
        width={250}
        theme="light"
        className={layoutStyles.sider}
        style={{ background: colorBgContainer }}
      >
        <div className={layoutStyles.siderTitle}>
          Администрирование
        </div>
        <Menu
          mode="inline"
          selectedKeys={activeKey}
          defaultOpenKeys={['access', 'system']}
          style={{ borderRight: 0 }}
          items={items}
        />
      </Sider>
      <Layout className={layoutStyles.contentLayout}>
        <Content
          className={layoutStyles.content}
          style={{ background: colorBgContainer }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
